import { render, staticRenderFns } from "./brochure-merge-regions.vue?vue&type=template&id=71763590&"
import script from "./brochure-merge-regions.vue?vue&type=script&lang=js&"
export * from "./brochure-merge-regions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports